import styled, {css} from 'styled-components';
import {NavLink} from 'react-router-dom';

interface ItemProps {
  readonly mWidth?: string;
  readonly mHeight?: string;
  readonly mTop?: string;
}

export const LogoContainer = styled(NavLink)`
  display: inline-block;
  text-decoration: none;
`;

export const Logo = styled.img<ItemProps>`
  ${props => {
    const resWidth = props.mWidth ? `max-width: ${props.mWidth};` : '';
    const resHeight = props.mHeight ? `max-height: ${props.mHeight};` : '';
    const resmTop = props.mHeight ? `margin-top: ${props.mTop};` : '';

    return css`
       {
        ${resWidth}
        ${resHeight}
        ${resmTop}
      }
    `;
  }}
`;
